export enum ReportPeriodMode {
    CUSTOM = "custom",
    TODAY = "today",
    THIS_MONTH = "this-month",
    LAST_MONTH = "last-month",
    THIS_MONTH_TO_DATE = "this-month-to-date",
    LAST_MONTH_TO_DATE = "last-month-to-date",
    LAST_MONTH_TO_TODAY = "last-month-to-today",
    THIS_QUARTER = "this-quarter",
    LAST_QUARTER = "last-quarter",
    THIS_QUARTER_TO_DATE = "this-quarter-to-date",
    LAST_QUARTER_TO_DATE = "last-quarter-to-date",
    LAST_QUARTER_TO_TODAY = "last-quarter-to-today",
    THIS_YEAR = "this-year",
    LAST_YEAR = "last-year",
    YEAR_TO_DATE = "year-to-date",
    THIS_YEAR_TO_LAST_MONTH = "this-year-to-last-month",
    LAST_YEAR_TO_DATE = "last-year-to-date",
    LAST_YEAR_TO_TODAY = "last-year-to-today",
    LAST_12_MONTHS = "last-12-months",
    LAST_3_FULL_MONTHS = "last-3-full-months",
    LAST_12_FULL_MONTHS = "last-12-full-months",
    LAST_30_DAYS = "last-30-days",
    LAST_60_DAYS = "last-60-days",
    LAST_90_DAYS = "last-90-days",
}
